import Vue from 'vue'
import App from './App.vue'

Vue.config.ignoredElements = [
  'onion-gl',
]

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')

window.addScript = function(link) {
  let tag = document.createElement("script");
  tag.src = link;
  document.getElementsByTagName("head")[0].appendChild(tag);
}